module.exports = __webpack_public_path__ + "static/media/002.e68c79e0.jpg";